import React from 'react';
import './ConversationalSearchSelectionItem.css';

const btnSize = 120

const stringToGradient = (str) => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h1 = Math.abs(hash) % 360;
  const h2 = (h1 + 60) % 360;

  return `linear-gradient(
      135deg,
      hsl(${h1}, 65%, 35%),  /* darker */
      hsl(${h2}, 65%, 25%)   /* even darker */
    )`;
};

const ConversationalSearchSelectionItem = ({ options, handleClick }) => {
  const gradient = stringToGradient(options.label || "default");

  return (
    <button
      className="circle-button"
      onClick={() => handleClick(options)}
    >
      <div
        className="circle-overlay"
        style={{
          backgroundImage: `
            radial-gradient(circle at 20% 30%, rgba(255,255,255,0.14) 3px, transparent 1.5px),
            radial-gradient(circle at 70% 20%, rgba(255,255,255,0.14) 0.5px, transparent 1.5px),
            radial-gradient(circle at 55% 85%, rgba(255,255,255,0.10) 2px, transparent 1.5px),
            radial-gradient(circle at 75% 65%, rgba(255,255,255,0.10) 2px, transparent 1.5px),
            radial-gradient(circle at 45% 80%, rgba(255,255,255,0.08) 1px, transparent 1.5px),
            radial-gradient(circle at 24% 50%, rgba(255,255,255,0.14) 1px, transparent 1.5px),
            linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.25)),
            ${gradient}
          `
        }}
      />
      {
        options.label == "Keine davon / Ist mir egal" ?
          (<div className="circle-text circle-text-xl"> ? </div>)
          :
          (<div className="circle-text">{options.label}</div>)
      }
    </button>
  );
};

export default ConversationalSearchSelectionItem;